import React from "react";
import {
  SiSpotify,
  SiAmazonmusic,
  SiApplemusic,
  SiItunes,
  SiYoutubemusic,
  SiTidal,
} from "react-icons/si";
import "./MusicalNetworks.scss";

const PLATFORMS = [
  {
    name: "Spotify",
    url: "https://open.spotify.com/artist/4qWQelQvxU5HZ2mIpiGt4U?si=50AY0YpIRUu9Tpw9oVn4iw",
    icon: <SiSpotify />,
  },
  {
    name: "Apple Music",
    url: "https://music.apple.com/co/album/damn-girl-single/1864395516",
    icon: <SiApplemusic />,
  },
  {
    name: "YouTube Music",
    url: "https://music.youtube.com/playlist?list=OLAK5uy_mxskR6NKem0mz4kpbIqCDs6jue98ntd8s",
    icon: <SiYoutubemusic />,
  },
  {
    name: "Amazon Music",
    url: "https://music.amazon.com/albums/B0GCPMGKNK",
    icon: <SiAmazonmusic />,
  },
  {
    name: "Tidal",
    url: "https://tidal.com/album/485086213",
    icon: <SiTidal />,
  },
  {
    name: "iTunes Store",
    url: "https://music.apple.com/co/album/damn-girl-single/1864395516",
    icon: <SiItunes />,
  },
];

const MusicalNetworks = () => {
  return (
    <div className="music-links">
      <div className="music-links__grid">
        {PLATFORMS.map((platform) => (
          <a
            key={platform.name}
            href={platform.url}
            target="_blank"
            rel="noopener noreferrer"
            className="music-links__item"
          >
            <span className="music-links__icon">
              {platform.icon}
            </span>
            <span className="music-links__label">
              {platform.name}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default MusicalNetworks;
